// extracted by mini-css-extract-plugin
module.exports =  {"button":"b429494557--button--vG76v"};